import { ISO8601DateTimeString } from '@autopylot-internal/tiles-client';
import { FeatureCollection } from 'geojson';
import { dayjs } from '../../support/helpers/dayjs.ts';
import { formatLocalDateAndTime } from '../../support/helpers/format.ts';
import { DefaultMissionTimeCalculator } from '../../missions/model/DefaultMissionTimeCalculator.ts';

export class MockAirspaceProvider {

    static inject = () => [DefaultMissionTimeCalculator];
    constructor(private missionTimeCalculator: DefaultMissionTimeCalculator) { }

    private mockAirspaceData: FeatureCollection = {
        type: 'FeatureCollection',
        features: []
    };

    // gets set by MapViewModel (likely a better way, but finding a circular mess and this was my last resort)
    map!: mapboxgl.Map;

    get = (): FeatureCollection => {
        return this.mockAirspaceData;
    };

    set = (feature: FeatureCollection) => {
        this.mockAirspaceData = feature;
        const source = this.map.getSource('mock:source:airspace') as mapboxgl.GeoJSONSource;
        source.setData(feature as any);
    };

    reset = () => {
        this.set({
            type: 'FeatureCollection',
            features: []
        });
    };

    repaint = () => {
        this.set(this.get());
    };

    help = () => {
        console.log('.addPartTimeNSUFR() to add a part-time feature that by default starts 30 mins after the default mission start time and lasts 3 hours');
    };

    addPartTimeNSUFR = ({ startTime }: { startTime?: ISO8601DateTimeString } = {}) => {
        const ALERTTIME = dayjs().toISOString();
        const defaultStartTime = this.missionTimeCalculator.calculate().startTime;
        const ACTIVETIME = startTime || dayjs(defaultStartTime).add(30, 'm').toISOString();
        const ENDTIME = dayjs(ACTIVETIME).add(3, 'hour').toISOString();
        this.set({
            'type': 'FeatureCollection',
            'features': [
                {
                    'type': 'Feature',
                    'properties': {
                        GLOBAL_ID: 'mock-parttime-nsufr',
                        'source': 'parttime-nsufr',
                        ALERTTIME,
                        ACTIVETIME,
                        ENDTIME,
                    },
                    'geometry': {
                        'type': 'Polygon',
                        'coordinates': [
                            [
                                [
                                    -106.5,
                                    32
                                ],
                                [
                                    -106,
                                    32
                                ],
                                [
                                    -106,
                                    31.5
                                ],
                                [
                                    -106.5,
                                    31.5
                                ],
                                [
                                    -106.5,
                                    32
                                ]
                            ]
                        ]
                    }
                }
            ]
        });

        const location: [number, number] = [
            -106.2649154663086,
            31.758969510446004
        ];

        this.map.setCenter(location);

        console.log(`active from ${formatLocalDateAndTime({ time: ACTIVETIME, withTimeZone: true, location: { lng: location[0], lat: location[1] } })} to ${formatLocalDateAndTime({ time: ENDTIME, location: { lng: location[0], lat: location[1] }, withTimeZone: true })}`);
        console.log('12300 Montwood Drive el paso tx');

    };
}
